import { InstallmentPaymentMethod, type InstallmentPaymentMethodType } from '../types/InstallmentPaymentMethod';
import { type DeviceType } from '../types/DeviceType';

export type ModalSize = {
  width: number;
  height: number;
};

/*
 * This modal sizes are stored temporary, until make sure they are coming from server.
 * Was put here to reduce duplication, as it is used in different components.
 * */
const CommonModalSize = {
  width: 770,
  height: 610,
} as const satisfies ModalSize;

export const CustomDesktopModalSize = {
  [InstallmentPaymentMethod.Laybuy]: {
    width: 390,
    height: 525,
  },
  [InstallmentPaymentMethod.Affirm]: {
    width: 610,
    height: 610,
  },
  [InstallmentPaymentMethod.PayPal]: {
    width: 640,
    height: 620,
  },
  [InstallmentPaymentMethod.Sezzle]: {
    width: 620,
    height: 580,
  },
} as const satisfies Partial<Record<InstallmentPaymentMethod, ModalSize>>;

// workaround to open modal to 100%, openModal doesn't support string values
// https://wix.slack.com/archives/CAKBA7TDH/p1604926273350300?thread_ts=1604922926.343800&cid=CAKBA7TDH
export const MobileModalSize: ModalSize = {
  width: 2000,
  height: 2000,
};

export const getModalSize = (
  deviceType: DeviceType,
  paymentMethod: InstallmentPaymentMethodType,
  sizeFromServer?: ModalSize,
): ModalSize =>
  // Gets modal size depends on payment method, gracefully falling back to the default size
  deviceType === 'mobile'
    ? MobileModalSize
    : sizeFromServer || CustomDesktopModalSize?.[paymentMethod] || CommonModalSize;
